<script lang="ts">
	import { getIconClasses } from './Icon.logic';
	import type { IconProps } from './Icon.types';

	let {
		icon,
		size = 'md',
		variant = 'default',
		class: className,
		strokeWidth = 2,
		...rest
	}: IconProps = $props();

	const finalClass = $derived(getIconClasses(size, variant, className));
</script>

{#if icon}
	{@const IconComponent = icon as any}
	<IconComponent class={finalClass} {...rest} size={undefined} {strokeWidth} />
{/if}
